import React, { Component } from 'react';
import store from 'store';
import moment from 'moment';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import FormGroup from 'components/Form/FormGroup';
import FlexGroup from 'components/FlexGroup';
import Datetime from 'components/Datetime';
import CustomView from 'components/Form/Input/CustomView';
import Attachment from 'components/Attachment/Attachment';
import { NavLink } from 'react-router-dom';
import buildActualPath from 'helpers/build-actual-path';
import {
    SCOOTER_PROFILE,
} from 'constants/routes';
import Input, {
    TYPE_HIDDEN,
    TYPE_TEXT,
    TYPE_TEXTAREA,
    TYPE_NUMBER,
    TYPE_CHECKBOX,
    TYPE_DATETIME,
    TYPE_SELECT,
    TYPE_SEARCH_DROPDOWNLIST,
    TYPE_RADIO,
} from 'components/Form/Input';
import {
    MAIN_TYPE_DISPATCH,
    MAIN_TYPE_MAINTENANCE,
    STATUS_CLOSED,
    SUB_TYPE_GROUP,
    GROUP_SEVERITY,
    CUSTOM_FIELD_DESTINATION,
    CUSTOM_FIELD_DMS_NO,
    CUSTOM_FIELD_MEGA_CENTRE,
} from 'constants/ticket';
import { SCOOTER_ONLINE } from 'constants/scooter';
import { convertOpUsers } from 'components/NewTicket';
import {
    updateOneTicket,
} from 'actions';
import Comment from "./Comment";

const HAVE_RM_OPTIONS = [
    { name: 'have', value: true, translate: true },
    { name: 'not_have', value: false, translate: true },
];

class TicketForm extends Component {
    static propTypes = {
        data: PropTypes.shape().isRequired,
        editMode: PropTypes.bool.isRequired,
        updating: PropTypes.bool.isRequired,
        onStartComment: PropTypes.func,
        onCompleteComment: PropTypes.func,
        onChange: PropTypes.func,
        children: PropTypes.node,
    };

    static defaultProps = {
        onStartComment: () => {},
        onCompleteComment: () => {},
        onChange: () => {},
        children: null,
    };

    constructor(props) {
        super(props);


        this.elComment = React.createRef();
        this.elStatus = React.createRef();
        this.elDestination = React.createRef();
        this.elDms_no = React.createRef();
        this.elMega_centre = React.createRef();
        this.attachment = undefined;
        this.state = {
            updateMediaSrc: undefined,
            hasComment: false,
            isCloseStatus: false,
            haveRM: [],
            test: [],
        };
        this.custom_fieldsObj = {
            [CUSTOM_FIELD_DESTINATION]: '',
            [CUSTOM_FIELD_DMS_NO]: '',
            [CUSTOM_FIELD_MEGA_CENTRE]: ''
        };

        this.elRMMileage = React.createRef();
        this.elRMDate = React.createRef();
        this.RMMileage = '';
        this.RMDate = '';
    }

    componentDidMount() {
        this.setCustom_fieldObj();
        this.setRegularMaintainObj();
    }

    componentDidUpdate(prevProps) {
        const { editMode } = this.props;
        if (editMode !== prevProps.editMode) {
            this.setCustom_fieldObj();
            // status might be change when editMode changes
            this.onChangeStatus();
            this.setRegularMaintainObj();

        }

        this.clearRMCustomErrorMessage();

    }

    get currentStatusId() {
        const { data, editMode } = this.props;
        return Number(
            editMode && this.elStatus.current ? this.elStatus.current.value : data.status_id
        );
    }

    setCustom_fieldObj() {
        const { data } = this.props;
        const { custom_fields = [] } = data;
        const destination = custom_fields.find(field => field.id === CUSTOM_FIELD_DESTINATION);
        const dmsNo = custom_fields.find(field => field.id === CUSTOM_FIELD_DMS_NO);
        const megaCentre = custom_fields.find(field => field.id === CUSTOM_FIELD_MEGA_CENTRE);

        this.custom_fieldsObj = {
            [CUSTOM_FIELD_DESTINATION]: destination?.value,
            [CUSTOM_FIELD_DMS_NO]: dmsNo?.value,
            [CUSTOM_FIELD_MEGA_CENTRE]: megaCentre?.value
        };
        this.setState({});
    }

    clearRMCustomErrorMessage = () => {
        if (this.elRMMileage.current) {
            this.handleRMMileageInputChange();
        }
        if (this.elRMDate.current) {
            this.handleRMDateInputChange();
        }
    }

    handleCustomFieldChange = () => {
        const destination = this.elDestination.current?.value;
        const dms_no = this.elDms_no.current?.value;
        const mega_centre = this.elMega_centre.current?.value;
        this.custom_fieldsObj = {
            [CUSTOM_FIELD_DESTINATION]: destination,
            [CUSTOM_FIELD_DMS_NO]: dms_no,
            [CUSTOM_FIELD_MEGA_CENTRE]: mega_centre
        };
    }

    handleRMMileageInputChange = () => {
        const { data } = this.props;
        const { total_mileage } = data;
        const el = this.elRMMileage.current;
        const mileage = el?.value;
        const { valid, rangeOverflow } = el.validity;

        this.RMMileage = mileage;

        el.setCustomErrorMessage('');
        if ((!valid || rangeOverflow) && (mileage > total_mileage)) {
            el.setCustomErrorMessage(I18n.t('validation_error.totalMileage'));
        }
    }

    handleRMDateInputChange = value => {
        const el = this.elRMDate.current;
        const inputValue = el?.value;
        const date = moment(inputValue);
        const { patternMismatch } = el.validity;
        const isFormatValid = !patternMismatch;

        this.RMDate = value || inputValue;

        el.setCustomErrorMessage('');
        if (isFormatValid && date.isValid() && !this.validRMDate(date)) {
            el.setCustomErrorMessage(I18n.t('validation_error.futureDate'));
        }
    }

    handleMediaPreview = e => {
        this.attachment = e.currentTarget.files[0];
        e.currentTarget.value = '';
        if (!this.attachment) {
            return;
        }

        const blob = new Blob([this.attachment]);
        const src = URL.createObjectURL(blob);
        this.setState({
            updateMediaSrc: src,
            hasComment: true,
        });
    }

    handleUpdateComment = async (payload) => {
        const { dispatch } = store;
        const { data } = this.props;
        const { id } = data;
        const response = await dispatch(updateOneTicket(id, payload));
        return response;
    }

    isCloseStatus = () => {
        return STATUS_CLOSED === this.currentStatusId;
    }

    onChangeStatus = () => {
        const isCloseStatus = this.isCloseStatus();
        if (!isCloseStatus) {
            const { onChange } = this.props;
            onChange('do_online', []);
        }
        this.setState({
            isCloseStatus,
        });

        this.setRegularMaintainObj([]);
    }

    setRegularMaintainObj = (haveRMValue) => {
        const { data, editMode } = this.props;
        const { maintain_date, maintain_mileage, total_mileage } = data;
        const isCloseStatus = this.isCloseStatus();
        const isCloseAndView = isCloseStatus && !editMode;
        const haveRM = (maintain_date !== null && maintain_mileage !== null) ? [true] : [false];
        this.setState({
            haveRM: (haveRMValue !== undefined) ? haveRMValue : haveRM,
        });

        this.RMMileage = isCloseAndView ? maintain_mileage : ( maintain_mileage ?? ( total_mileage || 0 ) );
        this.RMDate = isCloseAndView ? (maintain_date || '') : ( maintain_date || moment() );
    }

    handleHaveRMChange = (value) => {
        this.setRegularMaintainObj(value);
    }

    validRMDate = (currentDate) => {
        return currentDate.isBefore();
    }

    render() {
        const { isCloseStatus, haveRM } = this.state;
        const { data, editMode, onChange, updating, children } = this.props;
        const {
            assigned_to_id,
            assigned_to_editable,
            author,
            create_time,
            description,
            description_editable,
            due_date,
            due_date_editable,
            plate_no,
            plate_no_editable,
            scooter_model,
            scooter_model_display_name,
            scooter_model_display_name_editable,
            severity_id,
            severity_editable,
            status_editable_list = [],
            status_editable,
            status_id,
            tracker_id,
            tracker_editable,
            tracker_subtype_id,
            tracker_subtype_editable,
            update_time,
            notes_editable,
            custom_fields = [],
            journal = {},
            opUsers,
            scooter_id,
            doOnline,
            maintain_date_editable,
            maintain_mileage_editable,
            total_mileage,
        } = data;
        const { comments = [] } = journal;
        const statusOptions = status_editable_list.map(({ status_id }) => ({
            name: I18n.t(`ticket.status_${ status_id }`),
            value: status_id,
        }));
        const subTypeOptions = SUB_TYPE_GROUP[tracker_id]?.map(subTypeId => ({
            name: I18n.t(`ticket.sub_type_${ subTypeId }`),
            value: subTypeId,
        })) ?? [];
        const priortyOptions = GROUP_SEVERITY.map(severityId => ({
            name: I18n.t(`ticket.severity_${ severityId }`),
            value: severityId,
        }));
        const destinationEditable = custom_fields.find(field => field.id === CUSTOM_FIELD_DESTINATION)?.editable;
        const dmsNoEditable = custom_fields.find(field => field.id === CUSTOM_FIELD_DMS_NO)?.editable;
        const megaCentreEditable = custom_fields.find(field => field.id === CUSTOM_FIELD_MEGA_CENTRE)?.editable;
        const dateFormat = 'YYYY-MM-DD';
        const timeFormat = 'HH:mm';
        const fullTimeFormat = `${ dateFormat } ${ timeFormat }`;

        const isShowRM = this.currentStatusId === STATUS_CLOSED && tracker_id === MAIN_TYPE_MAINTENANCE;

        return (
            <div className="editable-section">
                <FormGroup title={ I18n.t('ticket.details') }>
                    <FlexGroup className="basic-info">
                        <Input
                            caption="ticket.main_type"
                            value={ tracker_id ? I18n.t(`ticket.main_type_${ tracker_id }`) : undefined }
                            viewMode={ !tracker_editable }
                        />
                        <Input
                            type={ TYPE_SELECT }
                            name="tracker_subtype_id"
                            caption="ticket.sub_type"
                            value={ subTypeOptions }
                            selected={ tracker_subtype_id }
                            viewMode={ !(editMode && tracker_subtype_editable) }
                        />
                        <CustomView
                            caption="scooter.plate"
                            onEditValue={ plate_no }
                            viewMode={ !plate_no_editable }
                        >
                            { plate_no && status_id === STATUS_CLOSED && (
                                plate_no
                            ) }
                            { plate_no && status_id !== STATUS_CLOSED && (
                                <NavLink to={ buildActualPath(SCOOTER_PROFILE, { scooterId: scooter_id }) }>
                                    { plate_no }
                                </NavLink>
                            ) }
                        </CustomView>
                        <Input
                            type={ TYPE_SELECT }
                            innerRef={ this.elStatus }
                            name="status_id"
                            caption="ticket.status"
                            value={ statusOptions }
                            selected={ status_id }
                            viewMode={ !(editMode && status_editable) }
                            onChange={ this.onChangeStatus }
                        />
                        <Input
                            type={ TYPE_TEXT }
                            name="scooter_model_display_name"
                            caption="scooter.model"
                            value={ scooter_model ? `${ scooter_model } (${ scooter_model_display_name || '--' })` : undefined }
                            viewMode={ !scooter_model_display_name_editable }
                        />
                        <Input
                            type={ TYPE_SEARCH_DROPDOWNLIST }
                            name="assigned_to_id"
                            caption="ticket.assignee"
                            value={ convertOpUsers(opUsers) }
                            selected={ assigned_to_id }
                            viewMode={ !(editMode && assigned_to_editable) }
                        />
                        <Input
                            type={ TYPE_SELECT }
                            name="severity_id"
                            caption="ticket.priority"
                            value={ priortyOptions }
                            selected={ severity_id }
                            viewMode={ !(editMode && severity_editable) }
                        />
                        <Input
                            type={ TYPE_DATETIME }
                            name="due_date"
                            caption="ticket.due_time"
                            dateFormat={ dateFormat }
                            timeFormat={ timeFormat }
                            value={ due_date }
                            viewMode={ !(editMode && due_date_editable) }
                            onChange={ m => onChange('due_date', m) }
                        />
                        { tracker_id === MAIN_TYPE_DISPATCH && (
                            <>
                                <Input
                                    type={ TYPE_HIDDEN }
                                    name="custom_fields[destination][id]"
                                    value={ CUSTOM_FIELD_DESTINATION }
                                />
                                <Input
                                    type={ TYPE_TEXT }
                                    name="custom_fields[destination][value]"
                                    caption="ticket.destination"
                                    value={ this.custom_fieldsObj[CUSTOM_FIELD_DESTINATION] }
                                    viewMode={ !(editMode && destinationEditable) }
                                    innerRef={ this.elDestination }
                                    onChange={ this.handleCustomFieldChange }
                                />
                            </>
                        ) }
                        { tracker_id === MAIN_TYPE_MAINTENANCE && (
                            <>
                                <Input
                                    type={ TYPE_HIDDEN }
                                    name="custom_fields[dms_no][id]"
                                    value={ CUSTOM_FIELD_DMS_NO }
                                />
                                <Input
                                    type={ TYPE_TEXT }
                                    name="custom_fields[dms_no][value]"
                                    caption="ticket.dms_no"
                                    value={ this.custom_fieldsObj[CUSTOM_FIELD_DMS_NO] }
                                    viewMode={ !(editMode && dmsNoEditable) }
                                    required={ isCloseStatus }
                                    innerRef={ this.elDms_no }
                                    onChange={ this.handleCustomFieldChange }
                                />
                            </>
                        ) }
                        { tracker_id === MAIN_TYPE_MAINTENANCE && (
                            <>
                                <Input
                                    type={ TYPE_HIDDEN }
                                    name="custom_fields[mega_center][id]"
                                    value={ CUSTOM_FIELD_MEGA_CENTRE }
                                />
                                <Input
                                    type={ TYPE_TEXT }
                                    name="custom_fields[mega_center][value]"
                                    caption="ticket.mega_center"
                                    value={ this.custom_fieldsObj[CUSTOM_FIELD_MEGA_CENTRE] }
                                    viewMode={ !(editMode && megaCentreEditable) }
                                    required={ isCloseStatus }
                                    innerRef={ this.elMega_centre }
                                    onChange={ this.handleCustomFieldChange }
                                />
                            </>
                        ) }
                        <Input
                            type={ TYPE_DATETIME }
                            caption="ticket.create_time"
                            dateFormat={ dateFormat }
                            timeFormat={ timeFormat }
                            value={ create_time }
                            viewMode
                        />
                        <Input
                            type={ TYPE_DATETIME }
                            caption="ticket.update_time"
                            dateFormat={ dateFormat }
                            timeFormat={ timeFormat }
                            value={ update_time }
                            viewMode
                        />
                        <Input
                            caption="ticket.reporter"
                            value={ author }
                            viewMode
                        />
                    </FlexGroup>
                </FormGroup>
                { isShowRM && (
                    <FormGroup title={ I18n.t('ticket.maintenance_title') }>
                        <FlexGroup className="basic-info have-regular-maintain">
                            <Input
                                className="have-RM"
                                name="have_RM"
                                type={ TYPE_RADIO }
                                caption="ticket.maintenance_subtitle"
                                value={ HAVE_RM_OPTIONS }
                                selected={ haveRM }
                                onChange={ this.handleHaveRMChange }
                                required
                                viewMode={ !editMode }
                            />
                        </FlexGroup>
                        <FlexGroup className="basic-info regular-maintain-info">
                            <Input
                                type={ TYPE_NUMBER }
                                name="maintain_mileage"
                                caption="ticket.maintenance_mileage"
                                innerRef={ this.elRMMileage }
                                onInput={ this.handleRMMileageInputChange }
                                value={ this.RMMileage }
                                viewMode={ !(editMode && maintain_mileage_editable) }
                                required={ isShowRM && haveRM[0] }
                                disabled={ editMode && !haveRM[0] }
                                max={ total_mileage }
                                step="0.1"
                                unitCaption={ I18n.t('km') }
                                min="0"
                            />
                            <Input
                                type={ TYPE_DATETIME }
                                name="maintain_date"
                                caption="ticket.maintenance_date"
                                dateFormat={ dateFormat }
                                timeFormat={ false }
                                innerRef={ this.elRMDate }
                                value={ this.RMDate }
                                onChange={ this.handleRMDateInputChange }
                                format={ dateFormat }
                                required={ isShowRM && haveRM[0] }
                                viewMode={ !(editMode && maintain_date_editable) }
                                disabled={ editMode && !haveRM[0] }
                                isValidDate={ this.validRMDate }
                            />
                        </FlexGroup>
                    </FormGroup>
                ) }
                { editMode && this.currentStatusId === STATUS_CLOSED && (
                    <FormGroup title={ I18n.t('action_panel.active_status') }>
                        <Input
                            name="scooter_state_action"
                            type={ TYPE_CHECKBOX }
                            withCaption={ false }
                            selected={ doOnline }
                            value={ [{
                                name: 'action_panel.online',
                                value: SCOOTER_ONLINE,
                                translate: true,
                            }] }
                            onChange={ v => onChange('do_online', v) }
                        />
                    </FormGroup>
                ) }
                <FormGroup title={ I18n.t('ticket.description') }>
                    <Input
                        type={ TYPE_TEXTAREA }
                        className="description"
                        name="description"
                        value={ description }
                        viewMode={ !(editMode && description_editable) }
                        withCaption={ false }
                        onChange={ e => onChange('description', e.target.value) }
                    />
                </FormGroup>
                {
                    !editMode ? (
                        <FormGroup title={ I18n.t('ticket.comment') }>
                            <section className="comment-wrapper">
                                {
                                    comments.map(({ id, author, notes, attachments, create_time }) => {
                                        return (
                                            <article key={ id } className="comment">
                                                <p className="notes">
                                                    { notes }
                                                </p>
                                                <div className="attachments-list">
                                                    {
                                                        attachments.map(({ id, url }, index) => (
                                                            <Attachment
                                                                key={ id }
                                                                src={ url }
                                                                allAttachments={ attachments }
                                                            />
                                                        ))
                                                    }
                                                </div>
                                                <p className="comment-footer">
                                                    <span className="author">{ author }</span>
                                                    <span>
                                                        <Datetime time={ create_time } format={ fullTimeFormat } />
                                                    </span>
                                                </p>
                                            </article>
                                        );
                                    })
                                }
                            </section>
                            <Comment
                                notes_editable={ notes_editable }
                                updating={ updating }
                                onUpdateComment={ this.handleUpdateComment }
                            />
                        </FormGroup>
                    ) : null
                }
                { children }
            </div>
        );
    }
}

export default TicketForm;
